import React, { Component } from 'react';

import NewsSlider from '../NewsSlider'
import Calendar from '../Calendar/Container'
import PodcastButton from '../PodcastButton'
import ImageSlider from '../ImageSlider'
import AlbumsButton from '../AlbumsButton'
import  tinymce from 'tinymce/tinymce';

class Home extends Component {

    componentDidMount(){
	this.props.loadEvents();
	this.props.loadStreamings();
    }

    render() {


	return (

	    <div>
		<ImageSlider images={[{image: '/images/shutterstock_480204967.jpg'}, {image: '/images/slika-ro.jpg'}, {image: '/images/hp-foto-03.jpg'}]} type="top" />


		{this.props.streamings.length > 0 &&
		 
		 <React.Fragment>
		     <h3 className="sectionTitle">TRENUTNI LIVE STRAMING</h3>

		     
		     {this.props.streamings.map(s =>
			 <React.Fragment>
			     <h2>{s.title}</h2>
			     <div className="video">
				 <div><iframe src={`https://www.youtube.com/embed/${s.stream_id}?autoplay=1`} frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></div>
			     </div>
			 </React.Fragment>
		     ) }
		 </React.Fragment>
		}
		
		<h3 className="sectionTitle">DOGODKI</h3>
		
		<NewsSlider news={this.props.events} />
		
		<hr />
		
		<div className="row">
		    <div className="col-lg-6">
			<AlbumsButton />
		    </div>
		    <div className="col-lg-6">
			<PodcastButton />
		    </div>
		</div>

		<div style={{marginTop: '16px'}}>
		    <ImageSlider images={this.props.slideshowPages} type="bottom" />
		</div>

		
	    </div>
	);
    }
}

export default Home;



// WEBPACK FOOTER //
// ./src/components/Home/index.jsx